const STORAGE_KEY = "sztama:selected-billing-product";

export interface BillingProductSelection {
  billingProductId: string;
  interval: "MONTH" | "YEAR";
}

export function saveBillingProductSelection(
  selection: BillingProductSelection,
) {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(selection));
  } catch {
    return;
  }
}

export function readBillingProductSelection(): BillingProductSelection | null {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);

    if (!raw) {
      return null;
    }

    const parsed: unknown = JSON.parse(raw);

    if (
      typeof parsed === "object" &&
      parsed !== null &&
      "billingProductId" in parsed &&
      typeof parsed.billingProductId === "string" &&
      "interval" in parsed &&
      (parsed.interval === "MONTH" || parsed.interval === "YEAR")
    ) {
      return {
        billingProductId: parsed.billingProductId,
        interval: parsed.interval,
      };
    }

    return null;
  } catch {
    return null;
  }
}

export function clearBillingProductSelection() {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    return;
  }
}
